/* eslint-disable react/prop-types */
import ToolTipButton from 'components/common/TooltipButton';
import Icon from 'components/icon';
import React, { useEffect, useState } from 'react';

const CopyTextButton = ({ text, label }) => {
  const [copySuccess, setCopySuccess] = useState('');

  useEffect(() => {
    if (copySuccess) {
      setTimeout(() => {
        setCopySuccess('');
      }, 3000);
    }
  }, [copySuccess]);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopySuccess('Copied!');
      })
      .catch(() => {
        setCopySuccess('Failed to copy!');
      });
  };

  return (
    <ToolTipButton
      disabled={!text}
      onClick={copyToClipboard}
      className={'p-0'}
      variant={'phoenix-secondary'}
      label={copySuccess || label}
    >
      <Icon fontSize="16px" icon="heroicons-outline:clipboard-list" />
    </ToolTipButton>
  );
};

export default CopyTextButton;
